// Après un déploiement, un onglet resté sur l'ancienne version peut demander un
// fichier qui n'existe plus : le serveur répond alors par la page HTML. Le garde
// `vite:preloadError` de main.jsx ne le voit pas quand c'est `vendor-preload`
// lui-même qui échoue (c'est ce fichier qui émet l'événement) : seul le boundary
// (components/Common/ErrorBoundary.jsx) attrape l'erreur. Observé le 2026-10-09,
// 10-12 et 10-13 (« Failed to load module script… MIME type of "text/html" »,
// Planning et tableau de bord inaccessibles).
const ERREUR_CHARGEMENT_FICHIER = /Failed to fetch dynamically imported module|Failed to load module script|Importing a module script failed|error loading dynamically imported module|Expected a JavaScript(-or-Wasm)? module script|Unable to preload CSS|MIME type of "text\/html"/i;
const CLE_REPARATION = 'rectorium:reparation-auto-deja-tentee';

export const estErreurChargementFichier = (error) => ERREUR_CHARGEMENT_FICHIER.test(String(error?.message || error || ''));

// Repart d'un état propre : désinscrit les service workers et vide les caches (un
// simple rechargement se fait resservir le shell périmé par l'ancien service
// worker), puis recharge. Meilleur effort : un échec d'une étape ne bloque pas la suite.
export const reparerEtRecharger = async () => {
  try {
    const inscriptions = (await navigator.serviceWorker?.getRegistrations?.()) || [];
    await Promise.all(inscriptions.map((i) => i.unregister()));
  } catch { /* meilleur effort */ }
  try {
    const noms = (await globalThis.caches?.keys?.()) || [];
    await Promise.all(noms.map((nom) => globalThis.caches.delete(nom)));
  } catch { /* meilleur effort */ }
  window.location.reload();
};

// Au plus UNE réparation automatique par onglet : si elle ne règle rien, on
// affiche l'écran d'erreur avec le détail plutôt que de recharger en boucle.
export const reparationDejaTentee = () => {
  try { return !!sessionStorage.getItem(CLE_REPARATION); } catch { return true; }
};
export const marquerReparationTentee = () => {
  try { sessionStorage.setItem(CLE_REPARATION, '1'); } catch { /* sessionStorage indisponible */ }
};
